import { useGqlQuery } from '@API/useAvQuery';
import { QueryKey } from '@fabric-ui/utils';
import { gql } from 'graphql-request';
import { useAvContext } from '../context/AvContextProvider';
import { PermissionAppName, PermissionEntitiesNames } from '../types';
import { PolicyType } from '../views/Policies/PolicyFiltersComponents/types';

export const usePoliciesList = ({ type, enabled = true }: { type: string; enabled?: boolean }) => {
  const {
    userPermissions: { hasAllowedPermissionToResource },
  } = useAvContext();
  return useGqlQuery<unknown, PolicyType[]>({
    queryKey: [QueryKey.Policies, type],
    query: GET_POLICIES_LIST,
    variables: { type },
    gcTime: 0,
    enabled: enabled && hasAllowedPermissionToResource({ resource: PermissionEntitiesNames.EXE_RULE, category: PermissionAppName.ASSETS }),
  });
};

const GET_POLICIES_LIST = gql`
  query findExecutionRulesByType($type: ExecutionType!) {
    findExecutionRulesByType(type: $type) {
      id
      metadata
      clientConfig
      lastSuccessfulRunAt
      executionRunConfiguration {
        id
        outcomes {
          outegrationId
        }
        active
        trigger {
          type
          value
        }
      }
    }
  }
`;
